"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parsers = exports.BufferParser = exports.DateParser = exports.ResourceIdParser = exports.ObjectIdParser = void 0;
const codecs = __importStar(require("./codecs"));
const t = __importStar(require("ts-codec"));
exports.ObjectIdParser = t.createParser(codecs.ObjectId._tag, (_, { target }) => {
    switch (target) {
        case t.TransformTarget.Encoded: {
            return { type: 'string' };
        }
        case t.TransformTarget.Decoded: {
            return { bsonType: 'ObjectId' };
        }
    }
});
exports.ResourceIdParser = t.createParser(codecs.ResourceId._tag, (_, { target }) => {
    switch (target) {
        case t.TransformTarget.Encoded: {
            return {
                type: 'object',
                properties: {
                    id: { type: 'string' }
                },
                required: ['id']
            };
        }
        case t.TransformTarget.Decoded: {
            return {
                type: 'object',
                properties: {
                    _id: { bsonType: 'ObjectId' }
                },
                required: ['_id']
            };
        }
    }
});
exports.DateParser = t.createParser(codecs.date._tag, (_, { target }) => {
    switch (target) {
        case t.TransformTarget.Encoded: {
            return { type: 'string' };
        }
        case t.TransformTarget.Decoded: {
            return { nodeType: 'date' };
        }
    }
});
exports.BufferParser = t.createParser(codecs.buffer._tag, (_, { target }) => {
    switch (target) {
        case t.TransformTarget.Encoded: {
            return { type: 'string' };
        }
        case t.TransformTarget.Decoded: {
            return { nodeType: 'buffer' };
        }
    }
});
exports.parsers = [exports.ObjectIdParser, exports.ResourceIdParser, exports.DateParser, exports.BufferParser];
